import { render, staticRenderFns } from "./Phishtank.vue?vue&type=template&id=162382c3&"
import script from "./Phishtank.vue?vue&type=script&lang=js&"
export * from "./Phishtank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports